// Practice info store module for managing customer/doctor data
import { getCustomersByClinicIdApi } from '@/api/setting';

const state = {
  clinicName: '',
  customers: {}, // Store customers by customer_id: { customer_id, customer_first_name, etc. }
  customersLoading: false,
  customersError: null
};

const getters = {
  // Get all customers
  getAllCustomers: (state) => {
    return Object.values(state.customers);
  },
  
  // Get customer by customer ID
  getCustomerById: (state) => (customerId) => {
    return state.customers[customerId] || null;
  },
  
  // Get clinic name
  getClinicName: (state) => {
    return state.clinicName;
  },
  
  // Get customers loading state
  getCustomersLoading: (state) => {
    return state.customersLoading;
  },
  
  // Get customers error
  getCustomersError: (state) => {
    return state.customersError;
  }
};

const mutations = {
  // Set clinic name
  SET_CLINIC_NAME(state, clinicName) {
    state.clinicName = clinicName;
  },
  
  // Set all customers
  SET_CUSTOMERS(state, customers) {
    // Convert array to object keyed by customer_id for easy lookup
    const customersObj = {};
    customers.forEach(customer => {
      customersObj[customer.customer_id] = customer;
    });
    state.customers = customersObj;
  },
  
  // Set loading state
  SET_CUSTOMERS_LOADING(state, isLoading) {
    state.customersLoading = isLoading;
  },
  
  // Set error
  SET_CUSTOMERS_ERROR(state, error) {
    state.customersError = error;
  },
  
  // Clear customers
  CLEAR_CUSTOMERS(state) {
    state.clinicName = '';
    state.customers = {};
    state.customersError = null;
  }
};

const actions = {
  // Fetch all customers by clinic ID
  async fetchCustomersByClinicId({ commit }, clinicId) {
    if (!clinicId) {
      console.error('Clinic ID is required to fetch customers');
      return;
    }
    
    commit('SET_CUSTOMERS_LOADING', true);
    commit('SET_CUSTOMERS_ERROR', null);
    
    try {
      console.log(`Fetching customers for clinic ID: ${clinicId}`);
      const response = await getCustomersByClinicIdApi(clinicId);
      
      if (response.data) {
        // Store clinic name
        if (response.data.clinic_name) {
          commit('SET_CLINIC_NAME', response.data.clinic_name);
        }
        
        // Store customers array
        if (response.data.customers && Array.isArray(response.data.customers)) {
          commit('SET_CUSTOMERS', response.data.customers);
          console.log(`✅ Loaded ${response.data.customers.length} customers for clinic ${clinicId}`);
        }
      }
      
      commit('SET_CUSTOMERS_LOADING', false);
      return response.data;
    } catch (error) {
      console.error('Error fetching customers:', error);
      commit('SET_CUSTOMERS_ERROR', error.message || 'Failed to fetch customers');
      commit('SET_CUSTOMERS_LOADING', false);
      throw error;
    }
  },
  
  // Clear customers data
  clearCustomers({ commit }) {
    commit('CLEAR_CUSTOMERS');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
